<template>
  <div>
    <v-navigation-drawer
        persistent
        :clipped="true"
        v-model="leftDrawer"
        enable-resize-watcher
        fixed
        app
        stateless
        hide-overlay
        width="230"
        :mini-variant.sync="mini"
    >
      <v-list dense>
        <template v-for="(item, idx) in menus">
          <div v-if="item.heading" v-bind:key="idx" class="subheader grey--text">
            {{ item.heading }}
          </div>
          <v-list-group
              v-else-if="item.children"
              v-model="item.model"
              :key="item.dbid"
              :prepend-icon="item.icon"
              no-action
          >
            <v-list-tile
                slot="activator"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.name }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.route"
                ripple
                :class="{'x-active-menu-item': $route.path.startsWith(child.route)}"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.name }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile
              v-else
              :to="item.route"
              :disabled="mini"
              :key="item.dbid"
              ripple
              :class="{'x-active-menu-item': $route.path.startsWith(item.route)}">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="idx === 0">
              <v-btn icon ripple @click.stop.prevent="mini = !mini">
                <v-icon>menu</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-bind:key="idx" v-if="idx === 0"/>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
        app
        :clipped-left="true"
        dark
        flat
        dense
        class="main-nav-bar"
        style="color: rgba(255,255,255,.85); background-color: rgb(0, 94, 166);"
    >

      <a id="logo" href="/" class="router-link-active">
        <img src="/static/logo.png">
      </a>

      <v-toolbar-title>
        | {{ title }}
      </v-toolbar-title>
      <v-spacer/>

      <v-toolbar-items>

        <v-btn
            flat
            dark
            to="/user"
        >
          <v-icon>account_circle</v-icon>
          {{ name }} [{{ username }}]
        </v-btn>

        <v-menu
            :nudge-bottom="48"
            bottom
            light
        >
          <v-btn slot="activator" flat dark>
            <v-icon>supervisor_account</v-icon>
            <span>{{ deptName }} / {{ roleName }}</span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile
                v-for="udr in deptRoles"
                :key="udr.dbid"
                ripple
                :to="udr.roleRoute"
                @click.native="$store.commit('changeRole', udr)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ udr.deptName }} / {{ udr.roleName }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn
            flat
            dark
            to="/login"
        >
          <v-icon>exit_to_app</v-icon>
          退出
        </v-btn>

      </v-toolbar-items>
    </v-toolbar>
    <v-content align-center>
      <router-view/>
    </v-content>
    <x-passwd
        v-model="diaChPasswd"
        :dbid="userId"
        v-on:ok="() => {return false}"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

import XPasswd from './user/Passwd'

const menuUri = '/api/index/menu';
const funcAndParamUri = '/api/index/funcs/and/params';

export default {
  components: {XPasswd},

  name: "Main",
  data() {
    return {
      leftDrawer: false,
      fixed: false,
      mini: false,
      title: '科研管理信息系统',
      menus: [],

      diaChPasswd: false
    }
  },
  created() {
    this.leftDrawer = true;
  },

  mounted() {
    // 弱密码检测
    window.console.log('弱密码检测')
    if (window.loginType === 'normal' && window.xutil.passwdStrength(this.passwordRaw) === 'weak') {
      this.diaChPasswd = true
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'authenticated',
      'name',
      'username',
      'passwordRaw',
      'deptId',
      'roleId',
      'deptName',
      'roleName',
      'deptRoles'
    ])
  },


  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    //console.log("in Main beforeRouteEnter");

    Vue.axios.all([
      Vue.axios.get(menuUri),
      Vue.axios.get(funcAndParamUri)
    ]).then(
        Vue.axios.spread(
            (rspMenu, rspFunc) => next(
                vm => {
                  vm.menus = rspMenu.data;
                  //console.log(rspFunc.data);
                  vm.$store.commit("funcsAndParams", rspFunc.data);
                })
        )
    )
  },

  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    //console.log("in Main beforeRouteUpdate");
    // window.console.log(from.path);
    if (this.menus.length === 0 || from.path === "/login") {
      Vue.axios.all([
        Vue.axios.get(menuUri),
        Vue.axios.get(funcAndParamUri)
      ]).then(
          Vue.axios.spread(
              (rspMenu, rspFunc) => {
                this.menus = rspMenu.data;
                //console.log(rspFunc.data);
                this.$store.commit("funcsAndParams", rspFunc.data);

                next();
              })
      )
    } else {
      next();
    }
  },

  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    //console.log("in Main beforeRouteLeave");
    const answer = window.confirm('确定要退出系统吗？');
    if (answer) {
      this.menus = [];
      // 退出系统，清空当前用户信息。
      this.$store.commit('logout');
      next()
    } else {
      next(false)
    }
  },

  watch: {
    roleId() {
      //console.log("in watch roleId");

      Vue.axios.all([
        Vue.axios.get(menuUri),
        Vue.axios.get(funcAndParamUri)
      ]).then(
          Vue.axios.spread(
              (rspMenu, rspFunc) => {
                this.menus = rspMenu.data;
                //console.log(rspFunc.data);
                this.$store.commit("funcsAndParams", rspFunc.data);
              })
      )
    }
  },

  methods: {}

}
</script>

<style>
#logo > img {
  height: 40px;
  vertical-align: middle;
}

main div.v-content__wrap {
  padding: 0 0rem;
}

.main-nav-bar {
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-width: 2px;
  border-bottom-style: solid;
}

.x-active-menu-item {
  border-right: 3px solid red;
  background-color: whitesmoke;
}

.x-active-menu-item .v-icon {
  color: #1976d2 !important
}


</style>
